import { createApp } from 'vue';
import GetChopraReportForm from '../../chopra-report/GetChopraReportForm.vue'
const appElements = document.querySelectorAll('.vue-get-chopra-form-view')
Array.from(appElements).forEach(element => {
  createApp(GetChopraReportForm).mount(element);
});
